import {
    BASE_CAT,
    DRESSING_CAT,
    SAUCE_CAT,
    STANDARD_CAT,
    TOPPING_CAT,
    PREMIUM_CAT,
    EXTRA_CAT,
} from "./index";

export const isBaseFilter = (ing) =>
    ing.categories.find((tag) => tag.startsWith(BASE_CAT));

export const isBowlBaseFilter = (ing) =>
    ing.categories.find((tag) => tag === `${BASE_CAT}-bowl`);

export const isRamenBaseFilter = (ing) =>
    ing.categories.find((tag) => tag === `${BASE_CAT}-ramen`);

export const isSaladBaseFilter = (ing) =>
    ing.categories.find((tag) => tag === BASE_CAT);

export const isDressingFilter = (ing) =>
    ing.categories.find((tag) => tag === DRESSING_CAT);

export const isSauceFilter = (ing) =>
    ing.categories.find((tag) => tag === SAUCE_CAT);

export const isStandardFilter = (ing) =>
    ing.categories.find((tag) => tag === STANDARD_CAT);

export const isToppingFilter = (ing) =>
    ing.categories.find((tag) => tag === TOPPING_CAT);
export const isExtraFilter = (ing) =>
    ing.categories.find((tag) => tag === EXTRA_CAT);
export const isPremiumFilter = (ing) =>
    ing.categories.find((tag) => tag === PREMIUM_CAT);

export const isAnythingElseFilter = (ing) =>
    !isBaseFilter(ing.ingredient) &&
    !isDressingFilter(ing.ingredient) &&
    !isSauceFilter(ing.ingredient) &&
    !isStandardFilter(ing.ingredient);

export const isFreeFilter = (ing) => ing.ingredient.isFree;
